// /**
//  * Validates and formats input to allow only positive decimal numbers with specified decimal places
//  * @param value - The input value to validate
//  * @param decimalPlaces - Maximum number of decimal places allowed (default: 2)
//  * @returns Formatted valid positive decimal number string
//  */
// export const validatePositiveDecimalNumber = (value: string, decimalPlaces: number = 2): string => {
//     // Remove all negative signs
//     let cleanValue = value.replace(/[-]/g, "");

//     // Allow only numbers and one decimal point
//     cleanValue = cleanValue.replace(/[^0-9.]/g, "");

//     // Handle multiple decimal points - keep only the first one
//     const decimalIndex = cleanValue.indexOf(".");
//     if (decimalIndex !== -1) {
//         cleanValue =
//             cleanValue.substring(0, decimalIndex + 1) + cleanValue.substring(decimalIndex + 1).replace(/\./g, "");
//     }

//     // Handle decimal places - limit to specified decimal places
//     if (cleanValue.includes(".")) {
//         const parts = cleanValue.split(".");
//         if (parts[1] && parts[1].length > decimalPlaces) {
//             cleanValue = parts[0] + "." + parts[1].substring(0, decimalPlaces);
//         }
//     }

//     // Handle leading zeros
//     if (cleanValue.includes(".")) {
//         // For decimal numbers, allow only one leading zero (e.g., 0.33)
//         const parts = cleanValue.split(".");
//         if (parts[0].length > 1 && parts[0].startsWith("0")) {
//             // Remove leading zeros except for the last one before decimal
//             parts[0] = "0";
//         } else if (parts[0].length > 1) {
//             // Remove leading zeros for non-zero numbers
//             parts[0] = parts[0].replace(/^0+/, "") || "0";
//         }
//         cleanValue = parts.join(".");
//     } else {
//         // For whole numbers entered as decimal input, remove all leading zeros
//         cleanValue = cleanValue.replace(/^0+/, "") || "0";
//     }

//     return cleanValue;
// };

// /**
//  * Validates and formats input to allow only positive whole numbers (no decimals)
//  * @param value - The input value to validate
//  * @returns Formatted valid positive whole number string
//  */
// export const validatePositiveWholeNumber = (value: string): string => {
//     // Remove all negative signs and non-numeric characters (including decimals)
//     let cleanValue = value.replace(/[-]/g, "");

//     // Allow only numbers (no decimal points)
//     cleanValue = cleanValue.replace(/[^0-9]/g, "");

//     // Remove leading zeros for whole numbers
//     cleanValue = cleanValue.replace(/^0+/, "") || "0";

//     return cleanValue;
// };

// /**
//  * Creates an onChange handler for positive decimal number inputs
//  * @param field - React Hook Form field object
//  * @param decimalPlaces - Maximum number of decimal places allowed (default: 2)
//  * @returns onChange handler function
//  */
// export const createPositiveDecimalNumberHandler = (field: any, decimalPlaces: number = 2) => {
//     return (e: React.ChangeEvent<HTMLInputElement>) => {
//         const validatedValue = validatePositiveDecimalNumber(e.target.value, decimalPlaces);
//         field.onChange(validatedValue);
//     };
// };

// /**
//  * Creates an onChange handler for positive whole number inputs (no decimals)
//  * @param field - React Hook Form field object
//  * @returns onChange handler function
//  */
// export const createPositiveWholeNumberHandler = (field: any) => {
//     return (e: React.ChangeEvent<HTMLInputElement>) => {
//         const validatedValue = validatePositiveWholeNumber(e.target.value);
//         field.onChange(validatedValue);
//     };
// };

// /**
//  * Common props for positive decimal number inputs
//  */
// export const getPositiveDecimalNumberInputProps = (decimalPlaces: number = 2) => ({
//     min: 0,
//     step: decimalPlaces === 0 ? 1 : parseFloat(`0.${"0".repeat(decimalPlaces - 1)}1`),
//     type: "tel" as const, // Using tel instead of number to allow better custom validation
// });

// /**
//  * Common props for positive whole number inputs (no decimals)
//  */
// export const getPositiveWholeNumberInputProps = () => ({
//     min: 0,
//     step: 1,
//     type: "tel" as const, // Using tel instead of number to allow better custom validation
// });

// export const validatePositiveWholeNumberNoLeadingZeros = (value: string): string => {
//     // Remove all negative signs and non-numeric characters (including decimals)
//     let cleanValue = value.replace(/[-]/g, "");
//     cleanValue = cleanValue.replace(/[^0-9]/g, "");

//     // Remove leading zeros except for "0"
//     if (cleanValue.length > 1) {
//         cleanValue = cleanValue.replace(/^0+/, "");
//     }
//     return cleanValue;
// };


// export const createPositiveWholeNumberHandler = (field: any) => {
//     return (e: React.ChangeEvent<HTMLInputElement>) => {
//         const validatedValue = validatePositiveWholeNumberNoLeadingZeros(e.target.value);
//         field.onChange(validatedValue);
//     };
// };

// export const validatePositiveDecimalNumberNoLeadingZeros = (value: string, decimalPlaces: number = 2): string => {
//     // Remove all negative signs
//     let cleanValue = value.replace(/[-]/g, "");

//     // Allow only numbers and one decimal point
//     cleanValue = cleanValue.replace(/[^0-9.]/g, "");

//     // Prevent starting with a decimal point
//     if (cleanValue.startsWith(".")) {
//         cleanValue = cleanValue.substring(1);
//     }

//     // Handle multiple decimal points - keep only the first one
//     const decimalIndex = cleanValue.indexOf(".");
//     if (decimalIndex !== -1) {
//         cleanValue =
//             cleanValue.substring(0, decimalIndex + 1) + cleanValue.substring(decimalIndex + 1).replace(/\./g, "");
//     }

//     // Handle decimal places - limit to specified decimal places
//     if (cleanValue.includes(".")) {
//         const parts = cleanValue.split(".");
//         if (parts[1] && parts[1].length > decimalPlaces) {
//             cleanValue = parts[0] + "." + parts[1].substring(0, decimalPlaces);
//         }
//     }

//     // Remove leading zeros except for "0" before decimal
//     if (cleanValue.includes(".")) {
//         const parts = cleanValue.split(".");
//         if (parts[0].length > 1 && parts[0].startsWith("0")) {
//             // Remove leading zeros except for the last one before decimal
//             parts[0] = "0";
//         } else if (parts[0].length > 1) {
//             // Remove leading zeros for non-zero numbers
//             parts[0] = parts[0].replace(/^0+/, "") || "0";
//         }
//         cleanValue = parts.join(".");
//     } else {
//         // For whole numbers entered as decimal input, remove all leading zeros
//         cleanValue = cleanValue.replace(/^0+/, "") || "0";
//     }

//     // Remove trailing decimal point if nothing follows it
//     // if (cleanValue.includes(".") && cleanValue.split(".")[1] === "") {
//     //     cleanValue = cleanValue.slice(0, -1);
//     // }

//     return cleanValue;
// };

// export const createPositiveDecimalNumberHandler = (field: any, decimalPlaces: number = 2) => {
//     return (e: React.ChangeEvent<HTMLInputElement>) => {
//         const validatedValue = validatePositiveDecimalNumberNoLeadingZeros(e.target.value, decimalPlaces);
//         field.onChange(validatedValue);
//     };
// };





/**
 * Validates and formats input to allow only positive decimal numbers with specified decimal places
 * @param value - The input value to validate
 * @param decimalPlaces - Maximum number of decimal places allowed (default: 2)
 * @returns Formatted valid positive decimal number string
 */
export const validatePositiveDecimalNumber = (value: string, decimalPlaces: number = 2): string => {
    // Remove all negative signs
    let cleanValue = value.replace(/[-]/g, "");

    // Allow only numbers and one decimal point
    cleanValue = cleanValue.replace(/[^0-9.]/g, "");

    // Handle multiple decimal points - keep only the first one
    const decimalIndex = cleanValue.indexOf(".");
    if (decimalIndex !== -1) {
        cleanValue =
            cleanValue.substring(0, decimalIndex + 1) + cleanValue.substring(decimalIndex + 1).replace(/\./g, "");
    }

    // Handle decimal places - limit to specified decimal places
    if (cleanValue.includes(".")) {
        const parts = cleanValue.split(".");
        if (parts[1] && parts[1].length > decimalPlaces) {
            cleanValue = parts[0] + "." + parts[1].substring(0, decimalPlaces);
        }
    }

    // Handle leading zeros
    if (cleanValue.includes(".")) {
        // For decimal numbers, allow only one leading zero (e.g., 0.33)
        const parts = cleanValue.split(".");
        if (parts[0].length > 1 && parts[0].startsWith("0")) {
            // Remove leading zeros except for the last one before decimal
            parts[0] = "0";
        } else if (parts[0].length > 1) {
            // Remove leading zeros for non-zero numbers
            parts[0] = parts[0].replace(/^0+/, "") || "0";
        }
        cleanValue = parts.join(".");
    } else {
        // For whole numbers entered as decimal input, remove all leading zeros
        cleanValue = cleanValue.replace(/^0+/, "") || "0";
    }

    return cleanValue;
};

/**
 * Validates and formats input to allow only positive whole numbers (no decimals)
 * @param value - The input value to validate
 * @returns Formatted valid positive whole number string
 */
export const validatePositiveWholeNumber = (value: string): string => {
    // Remove all negative signs and non-numeric characters (including decimals)
    let cleanValue = value.replace(/[-]/g, "");

    // Allow only numbers (no decimal points)
    cleanValue = cleanValue.replace(/[^0-9]/g, "");

    // Remove leading zeros for whole numbers
    cleanValue = cleanValue.replace(/^0+/, "") || "0";

    return cleanValue;
};

/**
 * Creates an onChange handler for positive decimal number inputs
 * @param field - React Hook Form field object
 * @param decimalPlaces - Maximum number of decimal places allowed (default: 2)
 * @returns onChange handler function
 */
export const createPositiveDecimalNumberHandler = (field: any, decimalPlaces: number = 2) => {
    return (e: React.ChangeEvent<HTMLInputElement>) => {
        const validatedValue = validatePositiveDecimalNumber(e.target.value, decimalPlaces);
        field.onChange(validatedValue);
    };
};

/**
 * Creates an onChange handler for positive whole number inputs (no decimals)
 * @param field - React Hook Form field object
 * @returns onChange handler function
 */
export const createPositiveWholeNumberHandler = (field: any) => {
    return (e: React.ChangeEvent<HTMLInputElement>) => {
        const validatedValue = validatePositiveWholeNumber(e.target.value);
        field.onChange(validatedValue);
    };
};

/**
 * Common props for positive decimal number inputs
 */
export const getPositiveDecimalNumberInputProps = (decimalPlaces: number = 2) => ({
    min: 0,
    step: decimalPlaces === 0 ? 1 : parseFloat(`0.${"0".repeat(decimalPlaces - 1)}1`),
    type: "tel" as const, // Using tel instead of number to allow better custom validation
});

/**
 * Common props for positive whole number inputs (no decimals)
 */
export const getPositiveWholeNumberInputProps = () => ({
    min: 0,
    step: 1,
    type: "tel" as const, // Using tel instead of number to allow better custom validation
});






export const formatPrice = (value: number | string | null | undefined) => {
  if (value === null || value === undefined || value === "") return "-";

  const str = value.toString();

  if (!str.includes(".")) {
    return `${str}.00`;
  }

  const [int, dec] = str.split(".");
  return dec.length === 1
    ? `${int}.${dec}`
    : `${int}.${dec.slice(0, 2)}`;
};






